export default __webpack_public_path__ + "static/media/gallery_01.9b2efab8.jpg";